module.exports = require("@bechtel/client-assets/dist/images/data-vault-inactive.svg");